const NebulaPreviewGate = ({ isVisible, children }) => (
  isVisible ? children : null
);

export default NebulaPreviewGate;